import { DefaultError, useMutation } from "@tanstack/react-query";
import { invalidateEntireModuleListQuery } from "entities/modules/queries/useModuleListByTagIdQuery";
import { duplicatePageModule } from "../api/duplicatePageModule";
import { invalidateModuleListByBrandPageQuery } from "../queries/useModuleListByBrandPageQuery";
import { PageModuleData } from "../types";

type Params = {
  module: PageModuleData;
  sourceBrandId: string;
  sourcePageId: string;
  targetBrandId: string;
  targetPageId: string;
};

export const useDuplicatePageModuleMutation = () => {
  const mutation = useMutation<string, DefaultError, Params>({
    mutationFn: async (params) => {
      return await duplicatePageModule({
        module: params.module,
        sourceBrandId: params.sourceBrandId,
        sourcePageId: params.sourcePageId,
        targetBrandId: params.targetBrandId,
        targetPageId: params.targetPageId,
      });
    },
    onSuccess: (newModuleId, params) => {
      invalidateModuleListByBrandPageQuery(
        params.targetBrandId,
        params.targetPageId,
      );

      invalidateEntireModuleListQuery();
    },
  });

  return {
    ...mutation,
  };
};
